<template>
  <BMDialog
    width="600px"
    :showDialog="Boolean(globalDialog)"
    :fullscreen="false"
    :showFooter="false"
    :showDivider="false"
    class="global-dialog"
    @closed="triggerAction(false)"
    @confirmed="triggerAction(true)"
    dialogTestId="global-dialog"
    :dialogStatus="globalDialog ? globalDialog.type : null"
  >
    <div v-if="globalDialog" class="text-center overflow-y-hidden">
      <v-icon
        v-if="notificationIcon"
        :color="notificationIcon.color"
        class="notification-icon"
      >
        {{ notificationIcon.icon }}
      </v-icon>
      <div
        v-if="globalDialog.msg"
        v-sanitize="globalDialog.msg"
        class="notification-message font-weight-bold mt-2"
        :class="globalDialog.description ? '' : 'pb-10'"
      ></div>
      <div
        v-if="globalDialog.description"
        v-sanitize="globalDialog.description"
        class="notification-description mt-3"
      ></div>

      <div class="my-5">
        <BMButton
          v-if="!hideSubmitButton"
          size="large"
          :title="submitText"
          data-cc="global-dialog-confirm-button"
          @clicked="triggerAction(true)"
        />
      </div>
    </div>
  </BMDialog>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BMDialog from '@/components/common/utilities/BMDialog.vue';
import BMButton from '@/components/common/utilities/BMButton';
import useDialogsStore from '@/stores/dialogs';

// Libs
const { t } = useI18n();

const dialogsStore = useDialogsStore();

const globalDialog = computed(() => dialogsStore.globalDialog);

const hideSubmitButton = computed(
  () => typeof globalDialog.value?.callback === 'undefined'
);

const notificationIcon = computed(() => {
  const notificationTypes = {
    success: { icon: 'huge:checkmark-circle', color: 'success' },
    error: { icon: '$close', color: 'error' },
    info: { icon: 'huge:information-circle', color: 'info' },
    warning: { icon: 'huge:alert-circle', color: 'warning' }
  };
  return notificationTypes[globalDialog.value?.type];
});

const submitText = computed(
  () => globalDialog.value?.submitText ?? t('generic.save')
);

const triggerAction = (isSubmit) => {
  if (globalDialog.value?.callback) globalDialog.value.callback(isSubmit);
  dialogsStore.toggleGlobalDialog(null);
};
</script>

<style scoped lang="scss">
.notification {
  &-icon {
    font-size: 90px;
  }

  &-message {
    font-size: 1.5rem;
    line-height: 1.1;
  }

  &-description {
    font-size: 14px;
    letter-spacing: normal;
  }
}
</style>
